export const SET_FAVORITES = "SET_FAVORITES";
export const INITIAL_FAVORITES = "INITIAL_FAVORITES";